<template>
  <v-slide-y-reverse-transition>
    <div
      class="legend-panel"
      :style="panelStyle"
    >
      <v-card>
        <v-card-text>
          <div
            v-for="(seccion, index) in seccionesLeyenda"
            :key="index"
            class="seccion-leyenda"
          >
            <p>
              <strong>
                {{ seccion.titulo }}
                <span
                  v-if="seccion.unidad"
                >
                  ({{ seccion.unidad }})
                </span>
              </strong>
            </p>

            <ul
              v-if="seccion.items"
              class="leyenda-list"
            >
              <li
                v-for="(item, i) in seccion.items"
                :key="i"
              >
                <span
                  class="color-box"
                  :style="{ backgroundColor: item.color }"
                />
                {{ item.label }}
              </li>
            </ul>

            <template
              v-else-if="seccion.clase"
            >
              <div
                :class="['legend-gradient', seccion.clase]"
              />
              <div
                class="legend-labels"
              >
                <span
                  v-for="(label, i) in seccion.labels"
                  :key="i"
                >
                  {{ label }}
                </span>
              </div>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-slide-y-reverse-transition>
</template>

<script>
export default {
  props: {
    value: Boolean,
    position: Object,
    modo: Number,
    simulacion: Object,
    modoColor: { type: String, default: 'normal' }
  },
  computed: {
    visible () {
      return this.value
    },
    panelStyle () {
      return {
        position: 'absolute',
        left: `${this.position?.left ?? 0}px`,
        bottom: `${this.position?.bottom ?? 0}px`,
        zIndex: 9999
      }
    },
    seccionesLeyenda () {
      switch (this.modo) {
        case 0: // Simulación
          if (this.simulacion.simulacion.TIPO === 'INCENDIO') {
            const secciones = [
              {
                titulo: 'Simulación',
                unidad: '',
                clase: 'gradiente-incendio',
                labels: [
                  'Inicial',
                  'Propagacion',
                  'Final'
                ]
              }
            ]

            if (this.simulacion.simulacion.VIENTOS) {
              secciones.push({
                titulo: 'Vientos',
                unidad: 'm/s',
                clase: `gradiente-vientos-${this.modoColor}`,
                labels: [
                  this.simulacion.velocidades.minSpeed,
                  (this.simulacion.velocidades.maxSpeed / 2).toFixed(2),
                  this.simulacion.velocidades.maxSpeed
                ]
              })
            }

            return secciones
          }

          return [
            {
              titulo: 'Vientos',
              unidad: 'm/s',
              clase: `gradiente-vientos-${this.modoColor}`,
              labels: [
                this.simulacion.velocidades.minSpeed,
                (this.simulacion.velocidades.maxSpeed / 2).toFixed(2),
                this.simulacion.velocidades.maxSpeed
              ]
            }
          ]

        case 1: // Longitud de llama
          return [
            {
              titulo: 'Longitud de llama',
              unidad: 'm',
              items: [
                { label: '0,00 - 0,25', color: '#66ff33' },
                { label: '0,25 - 0,50', color: '#ccff33' },
                { label: '0,50 - 0,75', color: '#ffff66' },
                { label: '0,75 - 1,00', color: '#fcbc1c' },
                { label: '1,00 - 2,00', color: '#ff6d33' },
                { label: '> 5', color: '#ff0000' }
              ]
            }
          ]

        case 2: // Intensidad
          return [
            {
              titulo: 'Intensidad de llama',
              unidad: 'kW/m',
              items: [
                { label: '0 - 175', color: '#66ff33' },
                { label: '175 - 350', color: '#b2ff4c' },
                { label: '350 - 700', color: '#ffff66' },
                { label: '700 - 1.400', color: '#feab45' },
                { label: '1.400 - 2.800', color: '#fd5724' },
                { label: '2.800 - 3.500', color: '#fc0404' },
                { label: '3.500 - 10.000', color: '#c70a2a' },
                { label: '10.000 - 25.000', color: '#921050' }
              ]
            }
          ]

        case 3: // Velocidad
          return [
            {
              titulo: 'Velocidad de propagación',
              unidad: 'm/min',
              items: [
                { label: '0,0 - 0,5', color: '#0099ff' },
                { label: '0,5 - 1,0', color: '#66ff33' },
                { label: '1,0 - 1,5', color: '#ccff33' },
                { label: '1,5 - 2,0', color: '#ffff66' },
                { label: '2,0 - 2,5', color: '#fcbc1c' },
                { label: '2,5 - 3,0', color: '#ff6d33' },
                { label: '3,0 - 4,0', color: '#fc0404' },
                { label: '4,0 - 5,0', color: '#c60000' },
                { label: '5,0 - 7,5', color: '#660033' },
                { label: '7,5 - 20', color: '#ff00ff' }
              ]
            }
          ]

        default:
          return [
            {
              titulo: 'Leyenda',
              unidad: '',
              items: [{ label: 'Sin información disponible', color: 'gray' }]
            }
          ]
      }
    }
  }
}
</script>

<style scoped>
.seccion-leyenda {
  margin-bottom: 1rem;
}

.legend-panel {
  width: 270px;
  background: white;
  border-radius: 1rem;
  transition:0.5s;
  opacity: 0.8;
  position: fixed;
  z-index: 9999;
}

.legend-panel:hover {
  transition:0.5s;
  opacity: 1;
}

.leyenda-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.leyenda-list li {
  display: flex;
  align-items: center;
  margin-bottom: 0.4rem;
}

.color-box {
  opacity: 1 !important;
  width: 16px;
  height: 16px;
  margin-right: 0.5rem;
  border-radius: 2px;
}

.legend-gradient {
  width: 100%;
  height: 12px;
  border-radius: 6px;
  margin-top: 0.5rem;
}

.gradiente-incendio {
  background: linear-gradient(to right, yellow 0%, orange 50%, red 100%);
}

.gradiente-vientos-normal {
  background: linear-gradient(to right, #0010d9 0%, #0080ff 50%, #00ffff 100%);
}

.gradiente-vientos-contrast {
  background: linear-gradient(to right, #00ff37 0%, #d9ff00 50%, #ff0000 100%);
}

.legend-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 4px;
}

</style>
